// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"headerWrapper___1Vm1Y","headerDefault":"headerDefault___1HWYr","navbar":"navbar___Jfzbq","logo":"logo___3RCuk","sponsorText":"sponsorText___JaNse"};